import React, {Component} from 'react';
import api from '../../utils/api';

export default class ClusterStrategyShort extends Component {

    constructor(props) {
        super(props);
        this.state = {
            prodTitles:{},
            prodShortTitles: {},
            prodMapping : {}
        }
    }

    componentWillMount(){
        let _self = this;
        api.get("filters/products/").then((out) => {
            let pTitles = {};
            let pShortTitles = {};
            let pMapping = {};
            let i = 1;

            out.data.forEach(e => {
                pTitles[i] = e.name;
                pShortTitles[i] = e.short_name;
                pMapping[e.name] = e.short_name;
                i++;
            });

            _self.setState({prodTitle : pTitles, prodShortTitles : pShortTitles, prodMapping : pMapping});
        })
    }

    render() {
        let _self = this;
        let data = _self.props.data;

        return <div className="row clusterStrategy clusterStrategyShort">
            <div className="row">
                <div className="col s12">
                    <div className="row">
                        <div className="marketShare">
                            <table className='c-table'>
                                <thead>
                                    <tr>
                                        <td>&nbsp;</td>
                                        {_self.state.prodShortTitles && Object.keys(_self.state.prodShortTitles).map(key =>
                                            <td key={key}>{_self.state.prodShortTitles[key]}</td>
                                        )}
                                    </tr>
                                </thead>
                                <tbody>
                                    {_self.state.prodMapping && data && data.prices && Object.keys(data.prices).map((k,i) => {
                                        if(k === "Nuevo Precio Referencia" || k === "Nuevo Diferencial (%)" || k === "Aumento (%)") {
                                            return <tr key={k+i}>
                                                <td>{k}</td>
                                                {Object.keys(data.prices[k]).map((field,j) => {
                                                    return <td key={field+i+j}><input readOnly="readonly" name={_self.state.prodMapping[field]} type="number" value={data.prices[k][field]}/></td>
                                                })}
                                            </tr>
                                        }
                                        return false;
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

}


// WEBPACK FOOTER //
// ./src/containers/simulador/clusterstrategy-short.js